export default __webpack_public_path__ + "static/media/ID_7.8f8a3465.png";